import React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTokenInfo } from "../../../utils/Guard";
import { useNavigate } from "react-router-dom";
import { Getpermissions } from "../../../store/permission-store/permission-actions";
import { permissionActions } from "../../../store/permission-store/permission-slice";
import { Button } from "primereact/button";
import ABADatatable from "../../../components/ABADataTable/ABADatatable";
const PermissionsHomePage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userInfo = getTokenInfo();
  const permission = useSelector((state) => state.permission);

  useEffect(() => {
    if (
      userInfo.Roles !== undefined &&
      userInfo.Roles.includes("permission.showAll")
    ) {
      dispatch(Getpermissions(userInfo.Email, true));
    } else if (
      userInfo.Roles !== undefined &&
      !userInfo.Roles.includes("permission.menu")
    ) {
      window.location.href = "/home";
    }
  }, [dispatch, userInfo.Email, userInfo.Roles]);

  const viewDetailHanlder = (val) => {
    navigate(`/permissions/detail/${val.id}`);
  };
  const editHanlder = (val) => {
    navigate(`/permissions/edit/${val.id}`);
  };
  const createHanlder = () => {
    dispatch(
      permissionActions.setpermission({
        permission: {
          id: 0,
          name: "",
          description: "",
          status: false,
        },
      })
    );
    navigate(`/permissions/create`);
  };

  const backHanlder = () => {
    navigate(`/`);
  };
  let actions = [];
  const buttons = (rowData) => {
    let buttons = [];
    const buttonEdit = (
      <Button
        label="Editar"
        icon="pi pi-file-edit"
        className="p-button-rounded p-button-success p-button-text"
        onClick={() => {
          editHanlder(rowData);
        }}
      />
    );
    const buttonView = (
      <Button
        label="Ver"
        icon="pi pi-info-circle"
        className="p-button-rounded p-button-text"
        onClick={() => {
          viewDetailHanlder(rowData);
        }}
      />
    );
    // if (
    //   userInfo.Roles !== undefined &&
    //   userInfo.Roles.includes("permission.edit")
    // ) {
    //   buttons.push(buttonEdit);
    // }
    if (
      userInfo.Roles !== undefined &&
      userInfo.Roles.includes("permission.view")
    ) {
      buttons.push(buttonView);
    }
    return buttons;
  };
  actions.push(buttons);

  const columns = [
    {
      field: "name",
      header: "Nombre",
      filterMatchMode: "contains",
    },

    {
      field: "description",
      header: "Descripción",
      filterMatchMode: "contains",
    },
    {
      field: "status",
      header: "Estado",
      filterMatchMode: "contains",
    },
  ];

  return (
    <>
      <div
        style={{ backgroundColor: "#133047", padding: "1%", height: "118vh" }}
      >
        <ABADatatable
          width="40%"
          height="100vh"
          title="Permisos"
          values={permission.permissions}
          rows={5}
          rowsPerPageOptions={[5, 10, 20]}
          Columns={columns}
          actions={actions}
          createButton={{
            label: "Agregar",
            onClick: createHanlder,
            permission: "permission.create",
          }}
          backButton={{
            label: "Regresar",
            onClick: backHanlder,
            permission: "goBack",
          }}
        />
      </div>
    </>
  );
};
export default PermissionsHomePage;
